import { IconButton, Tooltip } from 'components/mui';
import { VisibilityIcon } from 'components/icons';

const PreviewIncidentReportButton = ({ checklistID }) => {
	return (
		<Tooltip title={'Preview Incident Report'} placement="top">
			<IconButton
				onClick={() =>
					window.open(
						`/canappsv3/generate-incident-report?said=0&clid=${checklistID}`,
						'_blank',
					)
				}
				color={'primary'}
			>
				<VisibilityIcon />
			</IconButton>
		</Tooltip>
	);
};
export default PreviewIncidentReportButton;
